// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1StatePermissionsCreateSchema = z.object({
  state_permission: z.object({
    role_ids: z.optional(z.array(z.number().int()).describe("Role IDs to grant state permissions to")),
    team_lead: z.boolean().describe("Whether team leads have this permission").nullish(),
    project_lead: z.boolean().describe("Whether project leads have this permission").nullish(),
  }),
});
